import { Link } from "react-router-dom";

function FooterComponent() {
  return (
    <>
      <div className="bg-gray-800 h-12 flex items-center px-4 text-gray-300 text-sm border-t border-gray-700">
        Copyright 2025 © All rights reserved to{" "}
        <Link
          to="mailto:md.salmanezaz@gmail.com"
          className="ms-1 text-gray-100 font-medium"
        >
          Md. Salman Ezaz
        </Link>
      </div>
    </>
  );
}

export default FooterComponent;
